import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import BenchLink from 'link-preview/BenchLink';
import {processTaskSchemaURL} from 'processes/dao/ProcessSchemaDAO';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

import {ProcessTaskSchemaGraphQL} from '../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';

export const PLACEHOLDER_TASK_SCHEMA_NAME = 'No task schema selected';

export function getTaskSchemaNameItem(
  taskSchema: ProcessTaskSchemaGraphQL | null,
  isLink: boolean
): JSX.Element {
  if (taskSchema && isLink) {
    return (
      <BenchLink href={benchlingUtil.pathToURL(processTaskSchemaURL(taskSchema.id))}>
        {taskSchema.name}
      </BenchLink>
    );
  }
  return <div>{taskSchema?.name ?? PLACEHOLDER_TASK_SCHEMA_NAME}</div>;
}

export interface SelectTaskSchemaDropdownProps {
  taskSchema: ProcessTaskSchemaGraphQL | null;
  onSelectTaskSchemaId: (taskSchemaId: string) => void;
  possibleTaskSchemas: Array<ProcessTaskSchemaGraphQL>;
  isLink: boolean;
  disabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function SelectTaskSchemaDropdown(props: SelectTaskSchemaDropdownProps): JSX.Element {
  const optionDatas = props.possibleTaskSchemas.map(({id, name}) => ({name, value: id}));

  if (props.disabled) {
    return (
      <div
        className={css(styles.dropdown)}
        {...getTestProps({component: 'SelectTaskSchemaDropdown', element: 'name'})}
      >
        {getTaskSchemaNameItem(props.taskSchema, props.isLink)}
      </div>
    );
  }

  return (
    <SelectDropdown
      displayName={props.taskSchema?.name ?? 'Select a task schema'}
      className={css(styles.dropdown)}
      dataTestAttrs={props.dataTestAttrs}
      menu={
        <SearchableMenu
          selectedValue={props.taskSchema?.id}
          width={Menu.WIDTHS.FULL}
          scrollable={true}
          onSelect={props.onSelectTaskSchemaId}
          optionDatas={optionDatas}
        />
      }
    />
  );
}

const styles = StyleSheet.create({
  dropdown: {
    flex: '0.9',
    whiteSpace: 'normal',
  },
});
